import { toApiError } from "./api-error";

export const GENERIC_ERROR_MESSAGE = "Something went wrong. Please try again.";

// ResponseData.fail() and success(false) answer with these placeholders, PARAMETER_ERROR with "Parameter Error".
const GENERIC_MESSAGES = new Set([
  "fail",
  "failed",
  "error",
  "success",
  "db error",
  "parameter error",
  "null",
  "undefined",
  "[object object]"
]);

// GlobalExceptionHandler falls back to the exception class name or its getMessage().
const EXCEPTION_NAME = /(?:^|[\s.:])[A-Z][A-Za-z0-9_$]*(?:Exception|Throwable)\b/;
const JAVA_PACKAGE = /\b(?:java|javax|jakarta|org\.spring|com\.goer|com\.gymgoer)[\w$]*(?:\.[\w$]+)+/;
const INTERNAL_SERVER_ERROR = /internal server error/i;

// Stripe failures are forwarded raw, prefixed with the full-width colon used by the backend.
const RAW_STRIPE = /^stripe\s*[:：]/i;

export function isPresentableMessage(message: string) {
  const text = message.trim();
  if (!text) return false;
  if (GENERIC_MESSAGES.has(text.toLowerCase())) return false;
  if (INTERNAL_SERVER_ERROR.test(text)) return false;
  if (RAW_STRIPE.test(text)) return false;
  return !EXCEPTION_NAME.test(text) && !JAVA_PACKAGE.test(text);
}

/** Single place deciding what a failed request is allowed to show: backend copy, or one generic message. */
export function presentableMessage(error: unknown) {
  return presentableText(toApiError(error).message);
}

/** Same rules for a `ResponseData.message` read straight off a non-200 envelope. */
export function presentableText(message?: string | null) {
  const text = message ?? "";
  return isPresentableMessage(text) ? text.trim() : GENERIC_ERROR_MESSAGE;
}
